/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var ReceiptOutlineIcon = function ReceiptOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M7 9L15 9V7H7V9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 13H17V11H11V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13H7V11H9V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 17L17 17V15L11 15V17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17H7V15H9V17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6641 1.90754C12.6564 1.23574 11.3436 1.23574 10.3359 1.90754L9.32251 2.58313C8.93627 2.84062 8.42033 2.78022 8.10401 2.44047C6.28014 0.481493 3 1.77207 3 4.44866V19.5513C3 22.2279 6.28014 23.5185 8.10401 21.5595C8.42033 21.2198 8.93627 21.1593 9.32251 21.4168L10.3359 22.0924C11.3436 22.7642 12.6564 22.7642 13.6641 22.0924L14.6775 21.4168C15.0637 21.1593 15.5797 21.2198 15.896 21.5595C17.7199 23.5185 21 22.2279 21 19.5513V4.44866C21 1.77207 17.7199 0.481492 15.896 2.44047C15.5797 2.78022 15.0637 2.84062 14.6775 2.58313L13.6641 1.90754ZM11.4453 3.57164C11.7812 3.3477 12.2188 3.3477 12.5547 3.57164L13.5681 4.24723C14.77 5.04849 16.3755 4.86052 17.3598 3.80331C17.9459 3.17377 19 3.58851 19 4.44866V19.5513C19 20.4115 17.9459 20.8262 17.3598 20.1967C16.3755 19.1394 14.77 18.9515 13.5681 19.7527L12.5547 20.4283C12.2188 20.6523 11.7812 20.6523 11.4453 20.4283L10.4319 19.7527C9.23002 18.9515 7.62453 19.1394 6.64022 20.1967C6.0541 20.8262 5 20.4115 5 19.5513V4.44866C5 3.58851 6.0541 3.17377 6.64022 3.80331C7.62453 4.86052 9.23002 5.04849 10.4319 4.24723L11.4453 3.57164Z"
  }));
};
export default ReceiptOutlineIcon;